var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.392 34.392"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(1769.059 1738.079) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Fx_01_Next",
    transform: "translate(1734.667 1703.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M17.2,0A17.2,17.2,0,1,1,0,17.2,17.2,17.2,0,0,1,17.2,0Z",
    fill: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(1.144 8.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M113.245,124.97a2.632,2.632,0,0,0-1.117-1.842c-1.457-1.312-2.687-2.757-4.446-3.636a16.418,16.418,0,0,1-3.4-2.581c-.742-.656-2.12-2.339-3.225-1.569a2.519,2.519,0,0,0-.863,1.463,8.3,8.3,0,0,0-.292,2.322,9.045,9.045,0,0,1-.02,1.687c-.272,1.574-3.439.325-4.409.227-1.483-.151-2.97-.191-4.45-.391a44.95,44.95,0,0,0-4.685,0c-.2.017-2.928-.5-4.577.331-.846.426-.349,2.205-.381,2.777-.069,1.217-.414,2.375.1,2.633.406.2,1.718-.119,3.05-.1.589.007,8.434.394,10.582.208,1.527-.132,3.835-.689,4.981.76.794,1,.193,2.445-.215,3.658s-.264,3,1,3.209a2.522,2.522,0,0,0,1.776-.673l9.177-6.594c.664-.477,1.395-1.073,1.414-1.891",
    transform: "translate(-81.204 -115.144)",
    fill: "#fff"
  }))))));
};
export default __webpack_public_path__ + "static/media/left_icon.81870afe.svg";
export { SvgComponent as ReactComponent };